<template>
    <!--员工收益明细-->
    <pop-form v-if="show" width="990px" body-max-height="560px">
        <template v-slot:title>
            {{title}}
            <span class="close" @click="close">
                <i class="el-icon-close"></i>
            </span>
        </template>
        <div class="summary-box">
            <el-table :data="listData" height="460" style="width: 100%" ref="selectTable" class="table-box-1">
                <el-table-column prop="create_datetime" label="时间" />
                <el-table-column label="收益类型">
                    <template slot-scope="data">
                        {{data.row.type_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="money" label="金额">
                    <template slot-scope="data">
                        ¥{{data.row.money}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </pop-form>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    export default {
        name: "SummaryStoreData",
        components: {PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            item: {
                type: Object,
                default: () => ({})
            },
        },
        data: () => ({
            title: "收益详情",
            roleId: "",
            listData: [],
        }),
        mounted: function () {

        },
        methods: {
            close: function () {
                this.$emit("showChange", false);
            },
            //初始
            init: function () {
                this.title = this.item.type_name + "详情";
                this.listData = [];
                this.loadListData();
            },
            //加载数据
            loadListData: function () {
                let postData = {
                    type: this.item.type ? this.item.type : 0,
                    date: this.item.total_date
                };
                obj.postData("summary/get_store_income_detailed", postData, res => {
                    if(res.errcode === 0) {
                        if(res.data.length > 0) {
                            let sumIncome = 0;
                            res.data.forEach(val => {
                                sumIncome += parseFloat(val.money)
                            });
                            res.data.push({
                                money: sumIncome.toFixed(2),
                                create_datetime: "合计"
                            });
                        }
                        this.listData = res.data;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
        },
        watch: {
            show: function (val) {
                if(val) {
                    this.init();
                }
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
    }
    .summary-box{
        padding: 6px;
    }
    .role-box{
        margin-bottom: 16px;
    }
</style>
